import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { Paths } from "../../../paths";

export const ownershipTypesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getOwnershipTypesList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.ownershiptypes }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getOwnershipTypesById: builder.query<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.ownershiptypes }/${ id }`,
		method: 'GET'
	  })
	}),
	addOwnershipTypes: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.ownershiptypes }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editOwnershipTypes: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.ownershiptypes }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteOwnershipTypes: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.ownershiptypes }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetOwnershipTypesListQuery,
  useAddOwnershipTypesMutation,
  useEditOwnershipTypesMutation,
  useDeleteOwnershipTypesMutation
} = ownershipTypesApi;
